export const environment = {
  name: 'prod',
  production: true,
  reCaptcha: {
    siteKey: '6Lc9_SUsAAAAAIpNwvS2ecVkJFPAt-St3AsKP3gW',
  },
  apiRoot: 'https://api.paystashio.com/',
  websiteBaseUrl: 'https://www.paystashio.com/',
  dashboardBaseUrl: 'https://dashboard.paystashio.com/',
  sentry: {
    dsn: 'https://53a2b8de220bb9584668d6907b67b5d1@o19044.ingest.us.sentry.io/4507627585077248',
    tracePropagationTargets: ['https://api.paystashio.com/'],
    replaysSessionSampleRate: 0.1,
  },
  intercomAppId: 'swsfccxk',
};
